<div mat-dialog-title>
  <h2>Export</h2>
  <eiq-button
    [title]="'Close export dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    testId="export-translations-dialog-close"
    class="mat-dialog-title__close"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content class="export-translations-dialog__content">
  <span class="export-translations-dialog__description caption fs__sm"> Configure what to include in the excel export for {{ data.languageName }} </span>

  <div class="export-translations-dialog__options">
    <span class="fs__sm fw__600">Translation Status</span>
    <mat-checkbox color="primary" data-testid="export-translations-dialog-all-checkbox" [ngModel]="all$()" (ngModelChange)="onAllChange($event)">
      <span class="fs__sm">All</span>
    </mat-checkbox>
    <eiq-break-line></eiq-break-line>
    <mat-checkbox color="primary" data-testid="export-translations-dialog-missing-checkbox" [(ngModel)]="missing$">
      <span class="fs__sm">Missing</span>
    </mat-checkbox>
    <mat-checkbox color="primary" data-testid="export-translations-dialog-outdated-checkbox" [(ngModel)]="outdated$">
      <span class="fs__sm">Outdated</span>
    </mat-checkbox>
    <mat-checkbox color="primary" data-testid="export-translations-dialog-ignored-checkbox" [(ngModel)]="ignored$">
      <span class="fs__sm">Ignored</span>
    </mat-checkbox>
  </div>
</div>
<div mat-dialog-actions class="export-translations-dialog__actions">
  <eiq-button [text]="'Cancel'" [style]="'stroked'" [color]="'light'" testId="export-translations-dialog-cancel" (clicked)="onCancel()"></eiq-button>
  <eiq-button [text]="'Export'" [color]="'primary'" testId="export-translations-dialog-export" [disabled]="!canExport$()" (clicked)="onExport()"></eiq-button>
</div>
